import React from "react";

export const WalletIcon: React.FC = (props: any) => (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="far"
    data-icon="wallet"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    {...props}
  >
    <path
      fill="currentColor"
      d="M448 112V96c0-35.35-28.65-64-64-64H96C42.98 32 0 74.98 0 128v256c0 53.02 42.98 96 96 96h352c35.35 0 64-28.65 64-64V176c0-35.35-28.65-64-64-64zm16 304c0 8.82-7.18 16-16 16H96c-26.47 0-48-21.53-48-48V128c0-26.47 21.53-48 48-48h288c8.82 0 16 7.18 16 16v32H112c-8.84 0-16 7.16-16 16s7.16 16 16 16h336c8.82 0 16 7.18 16 16v240zm-80-160c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
    />
  </svg>
);

export const SearchIcon: React.FC = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

export const HashIcon: React.FC = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="4" y1="9" x2="20" y2="9" />
    <line x1="4" y1="15" x2="20" y2="15" />
    <line x1="10" y1="3" x2="8" y2="21" />
    <line x1="16" y1="3" x2="14" y2="21" />
  </svg>
);

export const CatgirlTraitIcon: React.FC = (props: any) => (
  <svg width="16" height="16" viewBox="0 0 16 16" data-testid="dropdown-icon">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      {...props}
    >
      <g id="icon/cat" stroke="currentColor" strokeWidth="1.5">
        <g id="Group" transform="translate(0.500000, 1.500000)">
          <path
            d="M0.469334549,8.77081735 L0.482884828,8.77783489 C0.478224217,8.77527379 0.473681571,8.77294426 0.469334549,8.77081735 Z M1.03463917,8.74700044 C1.33616622,8.81461344 1.6042432,8.99621227 1.83844219,9.31704627 C2.15438734,9.74986601 2.82574666,10.4065775 3.62519332,10.94159 C4.80092729,11.7284247 6.10128003,12.1712479 7.49617489,12.1389938 C9.09588695,12.1020038 10.4788154,11.5633184 11.6771441,10.6741763 C12.0305933,10.4119222 12.3491844,10.1324652 12.6442213,9.83719556 C12.7556386,9.72569034 12.8589345,9.61676299 12.9635328,9.5018856 C13.0237982,9.43569771 13.1854572,9.2540131 13.1823824,9.25742845 C13.3626638,9.05718139 13.5603964,8.90754331 13.7796395,8.80613072 C13.8518179,8.77274402 13.9189717,8.74594387 13.9853257,8.72442835 C13.8760117,8.50079681 13.7622347,8.25121878 13.6427365,7.97470195 C13.5016865,7.64831464 13.3544573,7.28867687 13.1911805,6.87482239 C13.0335855,6.47536931 12.5507106,5.21515299 12.5126586,5.11742621 C12.2974968,4.56483941 12.1585143,4.23929658 12.0857588,4.11658997 C11.1276663,2.501793 9.53473113,1.6875 7.51351244,1.6875 C5.35714344,1.6875 3.79141919,2.47927255 2.82007758,4.11640003 C2.75227135,4.23075935 2.62233558,4.55318383 2.42694552,5.09607808 C2.38206726,5.220773 1.94592243,6.45831011 1.80304728,6.84999256 C1.56102481,7.51348061 1.35142409,8.04638632 1.14851162,8.49976989 C1.11016096,8.58545983 1.07222421,8.66785932 1.03463917,8.74700044 Z"
            id="Stroke-12"
          />
          <path
            d="M3.90022,1.90850292 C2.73521457,1.30266217 2.01690736,0.921616276 1.73228368,0.758179819 C1.72377247,0.735935189 1.74598046,0.752699813 1.76006395,0.824881059 C1.84614688,1.26607637 2.05751737,2.32273864 2.39387761,3.99336025 L3.90022,1.90850292 Z M1.73228368,0.758179819 C1.72939205,0.756519391 1.72654519,0.754881423 1.72374307,0.753265908 C1.71243385,0.746745758 1.71162318,0.738815889 1.71621312,0.737727574 Z"
            id="Fill-4"
          />
          <path
            d="M13.2602197,1.90850292 C12.0952142,1.30266217 11.376907,0.921616276 11.0922833,0.758179819 C11.0837721,0.735935189 11.1059801,0.752699813 11.1200636,0.824881059 C11.2061465,1.26607637 11.417517,2.32273864 11.7538773,3.99336025 L13.2602197,1.90850292 Z M11.0922833,0.758179819 C11.0893917,0.756519391 11.0865448,0.754881423 11.0837427,0.753265908 C11.0724335,0.746745758 11.0716228,0.738815889 11.0762128,0.737727574 Z"
            id="Fill-4-Copy"
            transform="translate(12.368626, 2.911301) scale(-1, 1) translate(-12.368626, -2.911301) "
          />
        </g>
      </g>
    </g>
  </svg>
);

export const SchoolgirlTraitIcon: React.FC = (props: any) => (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="far"
    data-icon="backpack"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    {...props}
  >
    <path
      fill="currentColor"
      d="M320 80h-8V56c0-30.88-25.12-56-56-56h-64c-30.88 0-56 25.12-56 56v24h-8C57.31 80 0 137.31 0 208v240c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V208c0-70.69-57.31-128-128-128zM184 56c0-4.41 3.59-8 8-8h64c4.41 0 8 3.59 8 8v24h-80V56zm136 408H128v-64h192v64zm0-112H128v-32c0-17.67 14.33-32 32-32h128c17.67 0 32 14.33 32 32v32zm80 96c0 8.82-7.18 16-16 16h-16V320c0-44.11-35.89-80-80-80H160c-44.11 0-80 35.89-80 80v144H64c-8.82 0-16-7.18-16-16V208c0-44.11 35.89-80 80-80h192c44.11 0 80 35.89 80 80v240zm-96-288H144c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
    />
  </svg>
);

export const SwimsuitTraitIcon: React.FC = (props: any) => (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="far"
    data-icon="fish"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 512"
    {...props}
  >
    <path
      fill="currentColor"
      d="M360.18 64c-103.38 0-183.5 63.14-220.38 98.67l-72.88-56.3c-13.91-10.75-33.25-11.66-48.22-2.23C4.39 113.17-2.61 129.53.89 145.81L24.64 256 .89 366.19c-3.5 16.28 3.5 32.64 17.81 41.67 14.97 9.42 34.31 8.5 48.22-2.22l72.88-56.31c36.88 35.53 117 98.67 220.38 98.67C514.09 448 640 303.05 640 256S514.09 64 360.18 64zm0 336c-81.19 0-156.79-51.09-200.44-98.91l-14.91-16.31-92.72 71.63L73.77 256 52.11 155.59l92.72 71.63 14.91-16.31C203.4 163.09 278.99 112 360.18 112c125.22 0 227.97 119.88 231.85 143.2C588.15 280.13 485.4 400 360.18 400zM448 224c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
    />
  </svg>
);

export const EyesTraitIcon: React.FC = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 421.75 469.03"
    {...props}
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="YTOq0S.tif">
          <path
            fill="currentColor"
            d="M371.75,388.5c-3.76-12.13-9.61-14.93-21.62-10.69-14.49,5.12-26.48,23-24.13,36,.85,4.72,2.6,9.15,6.46,12.06,3.18,2.39,2,3.45-.4,5.19-36,26.57-78.74,26.36-115.84-.89-28.39-20.86-47.28-49-59.69-81.45-18.39-48.09-23-97.28-8.84-147.38a143.27,143.27,0,0,1,26.42-51.46c3.91,6.2,8.78,11.11,15.29,14,2.26,1,1.33,2.32,1,3.61a29.71,29.71,0,0,0-.16,16.27c3.41,12.24,13.7,19.8,26.78,19.8,13.77,0,24.84-8.53,28.61-22,4.48-16-5.41-32.3-22.75-37-2.7-.73-4.19-1.61-5.1-4.4-2.75-8.45-8.65-14-17.11-17.16a4.38,4.38,0,0,1,.71-1.17C248.48,84.2,329.75,89.2,366.25,147c12.35,19.57,20,41.26,25.71,63.59,10.28,40.09,12.87,80.46,3.64,121.14a176.33,176.33,0,0,1-21.07,52.56C373.7,385.68,372.77,387,371.75,388.5Zm-168.6-94.15c-.47,3.78-.87,6.37-1.09,9-2.07,24,2,46.53,15.87,66.6,13.06,18.93,30.7,31,54.16,32.3,36.72,2,71.24-27.21,76.52-63.77,3.25-22.49-.6-44.09-7.59-65.35a146.72,146.72,0,0,0-11.86-27.74,20.31,20.31,0,0,0-.5,4.81c-1.08,18-3.56,35.8-11.15,52.43-7.25,15.87-18.24,28.05-35.78,32.22-22.85,5.43-53.18.35-71.14-27.46C208.09,303.5,206,299.37,203.15,294.35Z"
          />
          <path
            fill="currentColor"
            d="M43.43,218.38c.4,10.6,4,20.53,6.56,30.67,7.17,28.9,14.67,57.72,22,86.57a23.2,23.2,0,0,1,.73,3.91,3.24,3.24,0,0,1-5.69,2.17,10.45,10.45,0,0,1-1.56-2.53C44.73,299.36,24,259.54,3.91,219.36c-5.68-11.38-5-21.66.85-32.26,1.2-2.19,2.35-4.42,3.76-6.47C43.16,129.85,80.31,81.22,127.64,41.29,143.33,28.06,159.74,15.94,178.41,7,195.33-1,212.34-2.21,230.23,3.71c30,9.92,57.22,25.06,83.3,42.45,35.23,23.48,67.9,50,94.35,83.38,4,5.08,7.6,10.53,11.1,16,1.47,2.29,4.66,5,1.21,7.8-3.21,2.65-5.13-.82-7.11-2.48-31.87-26.64-65.24-51.14-101.56-71.44a308.76,308.76,0,0,0-44.82-20.56c-32.21-11.76-63.11-8.2-93.15,7.16a160.76,160.76,0,0,0-38.73,28c-22.14,21.46-42.95,44.23-63.77,66.94C60,173,51.27,186.87,46.17,202.68A50.93,50.93,0,0,0,43.43,218.38Z"
          />
          <path
            fill="currentColor"
            d="M284.86,469c-51.08-1.11-99.08-16.79-141.19-49.48-1.79-1.39-4.51-2.68-2.62-5.47,1.64-2.41,3.91-.8,5.78.19,21.79,11.51,44.18,21.63,67.76,28.92,36.61,11.32,74,16.41,112.35,14.09,1.33-.08,2.67-.1,4-.24,2.06-.21,3.82.31,4.25,2.48.5,2.49-1.2,3.58-3.36,4.08-3.56.83-7.11,1.77-10.7,2.42C309.78,468.08,298.32,468.84,284.86,469Z"
          />
          <path
            fill="currentColor"
            d="M203.15,294.35c2.85,5,4.94,9.15,7.44,13,18,27.82,48.28,32.89,71.14,27.46,17.54-4.17,28.54-16.36,35.78-32.22,7.59-16.62,10.06-34.39,11.15-52.43a20.31,20.31,0,0,1,.5-4.81A146.72,146.72,0,0,1,341,273.11c7,21.26,10.84,42.86,7.59,65.35-5.28,36.56-39.8,65.75-76.52,63.77-23.45-1.26-41.1-13.37-54.16-32.3-13.84-20.07-17.94-42.65-15.87-66.6C202.28,300.72,202.68,298.13,203.15,294.35Z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const ChevronDownIcon: React.FC = (props: any) => (
  <svg {...props} width="12" height="12" viewBox="0 0 16 16">
    <path
      d="M3.619 3.729h8.762a.75.75 0 0 1 .637 1.146l-4.381 7.042a.75.75 0 0 1-1.274 0L2.982 4.875a.75.75 0 0 1 .637-1.146z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export const DungeonIcon: React.FC = (props: any) => (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fal"
    data-icon="dungeon"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    {...props}
  >
    <path
      fill="currentColor"
      d="M240 177.62V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V177.62c-5.23-.89-10.52-1.62-16-1.62s-10.77.73-16 1.62zm-64 41.51V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V189.36c-12.78 7.45-23.84 17.47-32 29.77zM512 296c0-9.08-3.04-17.47-8.16-24.19 5.46-7.31 8.33-16.36 7.98-25.49-1.32-35.19-9.76-69.17-25.09-100.97-4.49-9.32-12.48-16.41-21.94-19.99.86-10.14-2.16-20.28-8.51-28.26-21.34-26.85-47.37-48.83-77.36-65.33a40.004 40.004 0 0 0-19.19-4.93c-3.45 0-6.83.45-10.09 1.31-5.17-8.82-13.55-15.38-23.4-18.2C303.29 3.35 279.65 0 256 0s-47.29 3.35-70.25 9.95c-9.83 2.82-18.22 9.38-23.39 18.2-3.26-.86-6.64-1.31-10.09-1.31-6.69 0-13.33 1.7-19.19 4.92-30 16.5-56.03 38.48-77.37 65.34-6.34 7.98-9.36 18.11-8.5 28.25-9.47 3.59-17.45 10.67-21.94 19.99C9.95 177.15 1.51 211.12.18 246.33c-.35 9.12 2.52 18.17 7.98 25.48A39.772 39.772 0 0 0 0 296v64c0 9 2.99 17.31 8.02 24C2.99 390.69 0 399 0 408v64c0 22.05 17.94 40 40 40h64c22.06 0 40-17.95 40-40v-64c0-9-2.99-17.31-8.02-24 5.03-6.69 8.02-15 8.02-24v-64c0-8.92-2.93-17.16-7.88-23.82a40.01 40.01 0 0 0 8.04-21.96c.71-12.54 3.74-25.12 9.02-37.4 2.66-6.19 3.67-12.68 3.2-18.97 6-2.32 11.44-6.08 15.78-11.05 7.3-8.34 15.78-15.54 25.21-21.41 5.7-3.54 10.24-8.31 13.44-13.78 3.14.77 6.42 1.18 9.77 1.18 3.37 0 6.74-.42 10.01-1.26 9.42-2.41 17.48-3.53 25.39-3.53 7.92 0 15.99 1.12 25.41 3.53 3.28.84 6.65 1.26 10.02 1.26 3.36 0 6.63-.4 9.78-1.18 3.2 5.46 7.74 10.23 13.44 13.77 9.44 5.87 17.92 13.07 25.22 21.41 4.35 4.97 9.79 8.74 15.79 11.05-.48 6.29.54 12.78 3.2 18.97 5.28 12.28 8.31 24.86 9.02 37.39.46 8.26 3.39 15.81 8.04 21.96a39.793 39.793 0 0 0-7.88 23.82v64c0 9 2.99 17.31 8.02 24-5.03 6.69-8.02 15-8.02 24v64c0 22.05 17.94 40 40 40h64c22.06 0 40-17.95 40-40v-64c0-9-2.99-17.31-8.02-24 5.03-6.69 8.02-15 8.02-24V296zM112 472c0 4.42-3.58 8-8 8H40c-4.42 0-8-3.58-8-8v-64c0-4.42 3.58-8 8-8h64c4.42 0 8 3.58 8 8v64zm0-112c0 4.42-3.58 8-8 8H40c-4.42 0-8-3.58-8-8v-64c0-4.42 3.58-8 8-8h64c4.42 0 8 3.58 8 8v64zm11.78-159.82c-6.44 14.99-10.61 31.16-11.57 48.23-.24 4.22-3.51 7.58-7.74 7.58H40.41c-4.57 0-8.42-3.9-8.25-8.47 1.19-31.53 8.97-61.38 21.94-88.3 1.39-2.88 4.32-4.49 7.32-4.49 1.5 0 3.01.4 4.37 1.25l55.04 34.4c3.32 2.08 4.5 6.2 2.95 9.8zm56.7-65.97a143.632 143.632 0 0 0-32.4 27.51c-1.59 1.82-3.81 2.8-6.05 2.8-1.39 0-2.8-.38-4.08-1.18l-55-34.38c-4.07-2.54-5.16-8.21-2.17-11.97a225.31 225.31 0 0 1 67.73-57.21c1.2-.66 2.49-.96 3.77-.96 3.27 0 6.45 1.99 7.72 5.24l23.79 60.57c1.4 3.6-.04 7.55-3.31 9.58zm118.38-22.33c-1.21 3.08-4.24 4.91-7.45 4.91-.7 0-1.4-.08-2.09-.26-11.83-3.02-22.6-4.52-33.33-4.52-10.79 0-21.54 1.52-33.3 4.52-.7.18-1.4.26-2.09.26-3.21 0-6.23-1.83-7.44-4.92l-23.73-60.41c-1.72-4.39.64-9.47 5.17-10.77C214.11 35.09 234.69 32 256 32s41.89 3.09 61.42 8.7c4.53 1.3 6.9 6.38 5.17 10.77l-23.73 60.41zm75.19 51.47c-1.28.8-2.68 1.18-4.08 1.18-2.25 0-4.46-.98-6.05-2.8a144.07 144.07 0 0 0-32.4-27.51c-3.27-2.04-4.71-5.99-3.31-9.57L352 64.08c1.27-3.24 4.46-5.24 7.72-5.24 1.28 0 2.57.31 3.77.96a225.31 225.31 0 0 1 67.73 57.21c2.99 3.76 1.9 9.43-2.17 11.97l-55 34.37zm14.17 36.83c-1.55-3.61-.37-7.72 2.96-9.8l55.04-34.4a8.181 8.181 0 0 1 4.37-1.25c3 0 5.94 1.61 7.32 4.49 12.97 26.91 20.75 56.77 21.94 88.3.17 4.57-3.68 8.47-8.25 8.47h-64.06c-4.23 0-7.5-3.36-7.74-7.58-.97-17.07-5.14-33.23-11.58-48.23zM480 472c0 4.42-3.58 8-8 8h-64c-4.42 0-8-3.58-8-8v-64c0-4.42 3.58-8 8-8h64c4.42 0 8 3.58 8 8v64zm0-112c0 4.42-3.58 8-8 8h-64c-4.42 0-8-3.58-8-8v-64c0-4.42 3.58-8 8-8h64c4.42 0 8 3.58 8 8v64zM304 189.36V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V219.13c-8.16-12.3-19.22-22.32-32-29.77z"
    />
  </svg>
);

export const ArrowRightIcon: React.FC = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);
